<template>
	<div>
		<div @click="toggleSnowing"
			 class="rounded-full p-0.25 h-4 w-6 cursor-pointer flex items-center transition-all duration-200"
			 :class="{
				'bg-gray-500 justify-start': !isSnowing,
				'bg-blue-500 justify-end': isSnowing,
			 }"
		>
			<svg-icon icon="snowflake" set="local" class="w-3 h-3 text-white"></svg-icon>
		</div>
		<div v-if="isSnowing" class="snowflakes">
			<svg-icon
				icon="snowflake"
				set="local"
				v-for="n in snowflakeCount"
				:key="n"
				class="snowflake w-2 h-2"
				:style="generateSnowflakeStyle()"
			>
			</svg-icon>
		</div>
	</div>
</template>

<script>
export default {
	name: "Snowfall",
	data() {
		const isSnowing = Number(JSON.parse(localStorage.getItem("isSnowing")) || 0);

		return {
			isSnowing: isSnowing, // Включение/выключение снегопада
			snowflakeCount: 50, // Количество снежинок
		};
	},
	methods: {
		toggleSnowing() {
			this.isSnowing = this.isSnowing ? 0 : 1;
			localStorage.setItem("isSnowing", Number(JSON.stringify(this.isSnowing)));
		},
		generateSnowflakeStyle() {
			const size = Math.random() + 0.5; // Размер снежинки (от 0.5rem до 2rem)
			const duration = Math.random() * 10 + 5; // Длительность анимации (5-15 секунд)
			const delay = Math.random() * 5; // Задержка перед началом анимации (0-5 секунд)
			const position = Math.random() * 100; // Горизонтальное положение (%)

			return {
				width: `${size}rem !important`,
				height: `${size}rem !important`,
				animationDuration: `${duration}s`,
				animationDelay: `${-delay}s`,
				left: `${position}%`,
			};
		},
	},
};
</script>

<style scoped>
.snowflakes {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 9999;
	overflow: hidden;
}

.snowflake {
	position: absolute;
	top: -10%;
	left: 0;
	animation: fall linear infinite;
	font-size: 1.5rem;
	opacity: 0.8;
	z-index: 9999;
	color: #A0CAD9;
}

@keyframes fall {
	0% {
		transform: translateY(-100%) rotate(0deg);
	}
	100% {
		transform: translateY(120vh) rotate(360deg);
	}
}

/* Генерация случайных снежинок */
.snowflake:nth-child(odd) {
	animation-duration: 10s;
	animation-delay: calc(-5s * var(--i));
	left: calc(100% * var(--i));
}

.snowflake:nth-child(even) {
	animation-duration: 7s;
	animation-delay: calc(-3s * var(--i));
	left: calc(100% * var(--i));
}
</style>
